import { combineReducers } from 'redux';

const Profile = (state = false, action:any) => {

    switch (action.type) {
        case 'SetUserProfile':
            state = action.profileData;
            return state
        default:
            return state
    }
}
export const GetProfile = (state:any) => state.Profile;
export default combineReducers({
    Profile
});
